import { render, staticRenderFns } from "./IDMLPagePreview.vue?vue&type=template&id=1d03a453&scoped=true"
import script from "./IDMLPagePreview.vue?vue&type=script&lang=js"
export * from "./IDMLPagePreview.vue?vue&type=script&lang=js"
import style0 from "./IDMLPagePreview.vue?vue&type=style&index=0&id=1d03a453&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d03a453",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d03a453')) {
      api.createRecord('1d03a453', component.options)
    } else {
      api.reload('1d03a453', component.options)
    }
    module.hot.accept("./IDMLPagePreview.vue?vue&type=template&id=1d03a453&scoped=true", function () {
      api.rerender('1d03a453', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/idml-layers/IDMLPagePreview.vue"
export default component.exports